import axios from 'axios';
import { useFilterStore } from '@/stores';

const baseURL = ['production', 'staging'].includes(process.env.NODE_ENV ?? '')
    ? '/api'
    : 'http://localhost:3000/api';

const instance = axios.create({
    baseURL,
    headers: {
        'Content-type': 'application/json',
    },
});

instance.interceptors.request.use(
    (config) => {
        if (config.headers.authorization === undefined) {
            config.headers.authorization = 'Bearer ' + (localStorage.getItem('token') ?? '');
        }
        config.headers['Accept-Language'] = localStorage.getItem('locale') ?? '';

        const filterStore = useFilterStore();
        const storageLevel = localStorage.getItem('level');

        if (filterStore.level === null && storageLevel !== null) {
            filterStore.setLevel(JSON.parse(atob(storageLevel)));
        }
        config.headers['level'] = filterStore.level?.id;
        return config;
    },
    (error) => Promise.reject(error),
);

export default instance;
